var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.shouldNotify)?_c('div',{class:[`${_vm.$appPrefix}-cms-slider-item-aufbauplus`]},[_c('TextBildModule',{attrs:{"instance":_vm.instance}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }